import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  label: string;
  value: string;
  onChange: (font: string) => void;
}

function injectFontLink(family: string) {
  const id = `gfont-${family.replace(/\s+/g, "-")}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family)}:wght@400;600;700&display=swap`;
  document.head.appendChild(link);
}

export function GoogleFontPicker({ label, value, onChange }: Props) {
  const { t } = useTranslation("settings");
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      if (value && value.length > 1) injectFontLink(value);
    }, 500);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [value]);

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium">{label}</label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Inter"
        className="block w-full rounded border px-3 py-2 text-sm"
      />
      <div
        className="rounded border bg-card p-4 text-xl"
        style={{ fontFamily: value || "system-ui, sans-serif" }}
      >
        {t("fontFamily.previewSentence")}
      </div>
    </div>
  );
}
